import _ from 'lodash'
import React from 'react'
import T from 'prop-types'

class BoldSubstrings extends React.PureComponent {
  render() {
    const { text, boldIndices } = this.props
    return (
      <span>
        {_.map(
          text || '',
          (c, i) =>
            boldIndices.indexOf(i) > -1
              ? <b key={i}>
                  {c}
                </b>
              : c
        )}
      </span>
    )
  }
}

BoldSubstrings.displayName = 'BoldSubstrings'
BoldSubstrings.propTypes = {
  boldIndices: T.arrayOf(T.number), // Array of character indices which should be bolded
  text: T.string
}
BoldSubstrings.defaultProps = {
  text: '',
  boldIndices: [] // Array of character indices which should be bolded
}

export default BoldSubstrings
